import { createSlice } from "@reduxjs/toolkit";
import axios, { API_ENDPOINTS } from "src/utils/axios";

export const initialState = {
        read_access: true,
        write_access: true,
        access: true,
        loading: false
  };

  const slice = createSlice({
    name: "access_rights",
    initialState,
    reducers: {
      resetAccessRights(state) {
        state.read_access = true;
        state.write_access = true;
        state.access = true;
        state.loading = false;
      },
      denyAccessRights(state) {
        state.read_access = false;
        state.write_access = false;
        state.access = false;
        state.loading = false;
      },
      startPermissionCheck(state) {
        state.loading = true;
      },
      setReadAccess(state, action){
        state.read_access = action.payload;
        state.access = action.payload;
        state.loading = false;
      },
      setWriteAccess(state, action){
        state.write_access = action.payload;
        if (!state.read_access) {
          state.access = action.payload;
        }
        state.loading = false;
      },
      setFullAccess(state, action) {
        state.read_access = action.payload.read_access;
        state.write_access = action.payload.write_access;
        state.access = action.payload.read_access || action.payload.write_access;
        state.loading = false;
      },
    },
  });

  export const { resetAccessRights, setReadAccess, setWriteAccess, denyAccessRights, setFullAccess, startPermissionCheck } = slice.actions;

export default slice.reducer;

export function getPermissions(check_permission, permission_type) {

    return async (dispatch) => {
      const permissions = [false, true];
      try {
        const response = await axios.get(
            API_ENDPOINTS.checkpermission,{
                params:{
                    check_permission,
                    permission_type
        }});
        const _permission = response.data ? Object.keys(response.data):[];

        // For full_access, use setFullAccess to handle both permissions correctly
        if (permission_type === 'full_access' && _permission.includes('read_access') && _permission.includes('write_access')) {
          dispatch(slice.actions.setFullAccess({
            read_access: permissions[parseInt(response.data['read_access'])],
            write_access: permissions[parseInt(response.data['write_access'])]
          }));
        } else {
          // For individual permission checks
          if(_permission.includes('write_access'))dispatch(slice.actions.setWriteAccess(permissions[parseInt(response.data['write_access'])]));
          if(_permission.includes('read_access'))dispatch(slice.actions.setReadAccess(permissions[parseInt(response.data['read_access'])]));
        }

      } catch (error) {
        dispatch(slice.actions.denyAccessRights());
      }
    };
  }